import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Container, Row } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { putReporteTema } from "../../controllers/org";

function ReporteTema({ tema, reporte, equipo, onSubmit }) {
  const [date, setDate] = useState(reporte.fecha ? reporte.fecha : null);
  const [host, setHost] = useState(equipo.teamMembers.rows.filter(m => m.membership_id === reporte.anfitrion) || null);
  const [realStartTime, setRealStartTime] = useState(reporte.inicio_real ? new Date(reporte.inicio_real) : null);
  const [endTime, setEndTime] = useState(reporte.hora_final ? new Date(reporte.hora_final) : null);
  const [meetingRating, setMeetingRating] = useState(reporte.rating || '');
  const [accionSugerida, setAccionSugerida] = useState(reporte.accion_sugerida || '');
  const [observaciones, setObservaciones] = useState(reporte.observaciones || '');
  const [nextDate, setNextDate] = useState(reporte.fecha_proxima_reunion ? new Date(reporte.fecha_proxima_reunion) : null);
  const [nextHost, setNextHost] = useState(equipo.teamMembers.rows.filter(m => m.membership_id === reporte.anfitrion_proxima_reunion) || null);
  const [memberEvaluation, setMemberEvaluation] = useState(reporte.reporte_tema_members || []);
  const [alert, setAlert] = useState();

  function formatDate(d) {
    return `${d.getFullYear()}-${(d.getMonth() < 9 ? '0' : '') + (d.getMonth() + 1)}-${(d.getDate() < 10 ? '0' : '') + d.getDate()}T${(d.getHours() < 10 ? '0' : '') + d.getHours()}:${(d.getMinutes() < 10 ? '0' : '') + d.getMinutes()}`;
  }
  useEffect(() => {
    setDate((reporte.fecha && formatDate(new Date(reporte.fecha)) ) || '');
    setHost(equipo.teamMembers.rows.filter(m => m.membership_id === reporte.anfitrion) || null);
    setRealStartTime(reporte.inicio_real|| '');
    setEndTime(reporte.hora_final || '');
    setMeetingRating(reporte.rating || '');
    setAccionSugerida(reporte.accion_sugerida || '');
    setObservaciones(reporte.observaciones || '');
    setNextDate((reporte.fecha_proxima_reunion && formatDate(new Date(reporte.fecha_proxima_reunion))) || '');
    setNextHost(equipo.teamMembers.rows.filter(m => m.membership_id === reporte.anfitrion_proxima_reunion) || null);
    setMemberEvaluation(reporte.reporte_tema_members || []);
    setAlert();
  }, [reporte]);

  function handleMemberEvaluationChange(membershipId, e) {
    let newMemberEvaluation;
    if (!memberEvaluation.filter(ev => ev.membership_id === membershipId).length) {
      newMemberEvaluation = memberEvaluation;
      newMemberEvaluation.push({
        membership_id: membershipId,
        [e.target.name]: parseInt(e.target.value)
      });
    }
    newMemberEvaluation = memberEvaluation.map((evaluation => {
      if (evaluation.membership_id === membershipId) {
        evaluation[e.target.name] = parseInt(e.target.value);
      }
      return evaluation;
    }));
    setMemberEvaluation(newMemberEvaluation);
  }

  function renderPersonEvaluation(title, membershipId, personNum = 1) {
    let existingEvaluation = memberEvaluation?.filter((evaluation => evaluation.membership_id === membershipId))[0] || {};

    return <Col xs={equipo.teamDetails.etapa.type === 1 ? 6 : 12} className="person-evaluation">
      <Row className="text-center">
        {equipo.teamDetails.etapa.type === 1 && <p>{title}</p>}
      </Row>
      <Row>
        <Form.Group className="mb-1 mt-1">
          <Form.Label>Puntualidad</Form.Label>
          <Form.Control type="number" name={`puntualidad_${personNum}`} placeholder="Puntualidad" value={existingEvaluation[`puntualidad_${personNum}`] || ''} onChange={handleMemberEvaluationChange.bind(null, membershipId)} required max={5} min={0} />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-1 mt-1">
          <Form.Label>Estudio</Form.Label>
          <Form.Control type="number" name={`estudio_${personNum}`} placeholder="Estudio" value={existingEvaluation[`estudio_${personNum}`] || ''} onChange={handleMemberEvaluationChange.bind(null, membershipId)} required max={5} min={0} />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-1 mt-1">
          <Form.Label>Participación</Form.Label>
          <Form.Control type="number" name={`participacion_${personNum}`} placeholder="Participación" value={existingEvaluation[`participacion_${personNum}`] || ''} onChange={handleMemberEvaluationChange.bind(null, membershipId)} required max={5} min={0} />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-1 mt-1">
          <Form.Label>Cumplimiento de acción sugerida</Form.Label>
          <Form.Control type="number" name={`accion_sugerida_${personNum}`} placeholder="Cumplimiento de acción sugerida" value={existingEvaluation[`accion_sugerida_${personNum}`] || ''} onChange={handleMemberEvaluationChange.bind(null, membershipId)} required max={5} min={0} />
        </Form.Group>
      </Row>
      {/* <Row>
        <Form.Group className="mb-1 mt-1">
          <Form.Label>Reunión Familiar</Form.Label>
          <Form.Control type="number" name={`reunion_familiar_${personNum}`} placeholder="Reunión Familiar" value={existingEvaluation[`reunion_familiar_${personNum}`] || ''} onChange={handleMemberEvaluationChange.bind(null, membershipId)} required />
        </Form.Group>
      </Row> */}
    </Col>
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const d = new Date(date);
    const reporteDeTema = {
      team_id: equipo.teamDetails.team_id,
      tema_id: tema.tema_id,
      fecha: d,
      anfitrion: host[0].membership_id,
      inicio_real: realStartTime,
      hora_final: endTime,
      rating: meetingRating,
      accion_sugerida: accionSugerida,
      observaciones: observaciones,
      fecha_proxima_reunion: new Date(nextDate),
      anfitrion_proxima_reunion: nextHost[0].membership_id,
      reporte_tema_members: memberEvaluation,
    };

    try {
      const data = await putReporteTema(reporteDeTema.team_id, reporteDeTema);
      setAlert(<Alert variant="success">El reporte se ha guardado con éxito.</Alert>);
      if (onSubmit) {
        onSubmit();
      }
    }
    catch (e) {
      setAlert(<Alert variant="warning">Ocurrió un error al guardar el reporte. Intenta de nuevo más tarde.</Alert>);
    }
  }

  return <Container>
    <Row>
      <Col>
        {alert}
        <h2>Tema {tema.tema_num}: {tema.title}</h2>
        <Form onSubmit={handleSubmit}>
          <Card>
            <Card.Header>Evalua la reunión</Card.Header>
            <Card.Body>
              <Row>
                <Col lg={3}>
                  <Form.Group className="mb-2 mt-1">
                    <Form.Label>Fecha y hora programada</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      value={date}
                      onChange={(ev) => setDate(ev.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <Form.Group className="mb-2 mt-1">
                    <Form.Label>Anfitrión</Form.Label>
                    <Typeahead
                      id="host"
                      name="host"
                      labelKey="label"
                      onChange={(selected) => {
                        setHost(selected);
                      }}
                      options={equipo.teamMembers.rows}
                      placeholder="Selecciona un miembro"
                      renderMenuItemChildren={(option) => (
                          <span>{option.label}</span>
                      )}
                      selected={host}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <Form.Group className="mb-2 mt-1">
                    <Form.Label>Empezó a las:</Form.Label>
                    <Form.Control
                      type="time"
                      value={realStartTime}
                      onChange={(ev) => setRealStartTime(ev.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <Form.Group className="mb-2 mt-1">
                    <Form.Label>Terminó a las:</Form.Label>
                    <Form.Control
                      type="time"
                      value={endTime}
                      onChange={(ev) => setEndTime(ev.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col lg={12}>
                  <Form.Group className="mb-2 mt-1">
                    <Form.Label>La reunión fue:</Form.Label>
                    <Container>
                      <Row>
                        <Col md={4} className="text-center">
                          <Form.Check type="radio" className='mb-4' >
                            <Form.Check.Input id='rating-buena' type="radio" name='rating' className='btn-check' value="buena" onChange={e => {setMeetingRating(e.target.value)}} checked={meetingRating === 'buena'} />
                            <Form.Check.Label htmlFor='rating-buena' className='btn btn-dark p-3' >Buena</Form.Check.Label>
                          </Form.Check>
                        </Col>
                        <Col md={4} className="text-center">
                          <Form.Check type="radio" className='mb-4' >
                            <Form.Check.Input id='rating-regular' type="radio" name='rating' className='btn-check' value="regular" onChange={e => setMeetingRating(e.target.value)} checked={meetingRating === 'regular'}  />
                            <Form.Check.Label htmlFor='rating-regular' className='btn btn-dark p-3' >Regular</Form.Check.Label>
                          </Form.Check>
                        </Col>
                        <Col md={4} className="text-center">
                          <Form.Check type="radio" className='mb-4' >
                            <Form.Check.Input id='rating-deficiente' type="radio" name='rating' className='btn-check' value="deficiente" onChange={e => setMeetingRating(e.target.value)} checked={meetingRating === 'deficiente'}  />
                            <Form.Check.Label htmlFor='rating-deficiente' className='btn btn-dark p-3' >Deficiente</Form.Check.Label>
                          </Form.Check>
                        </Col>
                      </Row>
                    </Container>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mb-2 mt-1">
                    <Form.Label>Acción sugerida:</Form.Label>
                    <Form.Control as="textarea" className="w-100" rows={3} placeholder="Acción sugerida" value={accionSugerida} onChange={(e => setAccionSugerida(e.target.value))} required />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mb-2 mt-1">
                    <Form.Label>Observaciones:</Form.Label>
                    <Form.Control as="textarea" className="w-100" rows={3} placeholder="Observaciones" value={observaciones} onChange={(e => setObservaciones(e.target.value))} required />
                  </Form.Group>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Card className="mt-5">
            <Card.Header>Próxima reunión</Card.Header>
            <Card.Body>
              <Row>
                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Fecha</Form.Label>
                      <Form.Control
                        type="datetime-local"
                        value={nextDate}
                        onChange={(ev) => setNextDate(ev.target.value)}
                      />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Anfitrión</Form.Label>
                    <Typeahead
                      id="nextHost"
                      name="nextHost"
                      labelKey="label"
                      onChange={(selected) => {
                        setNextHost(selected);
                      }}
                      options={equipo.teamMembers.rows}
                      placeholder="Selecciona un miembro"
                      renderMenuItemChildren={(option) => (
                          <span>{option.label}</span>
                      )}
                      selected={nextHost}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <p>Nota: si esta fecha no ha pasado, se enviará un email a los miembros del equipo con la información de la próxima reunión.</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          <Row>
          </Row>
          <Row className="mt-5">
            <p>Evaluar los cuatro aspectos del cuadro siguiente dea cuerdo a la siguiente escala:</p>
            <p>Excelente (5), Buena (4), Regular (3), Deficiente (2), Nula (1)</p>
              {equipo.teamMembers.rows.map(member => 
                <Col sm={12} md={6} style={{
                  marginBottom: '1rem'
                }}
                key={`membership-${member.membership_id}-tema-${tema.tema_id}`}>
                    <Card>
                      <Card.Header>Evaluar a {member.label}</Card.Header>
                      <Card.Body>
                        <Row>
                          {renderPersonEvaluation('Él', member.membership_id, 1)}
                          {equipo.teamDetails.etapa.type === 1 && renderPersonEvaluation('Ella', member.membership_id, 2)}
                        </Row>
                      </Card.Body>
                    </Card>
                </Col>)}
          </Row>

          <Row>
            <Form.Group className="mb-3 submit-buttons-wrapper">
              <Button key='submit-btn-reporte-tema' type='submit' variant='primary'>Guardar</Button>
            </Form.Group>
          </Row>
        </Form>
      </Col>
    </Row>
  </Container>
}

export default ReporteTema;